import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { versions, versionFilters } from "@/mocks/versions";

export default function VersionUpdates() {
  const [filter, setFilter] = useState("all");

  const list = useMemo(
    () => (filter === "all" ? versions : versions.filter((v) => v.platform === filter)),
    [filter]
  );

  return (
    <section id="versions" className="scroll-mt-24 w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="最新版更新"
            title="版本更新说明一览"
            desc="按平台筛选查看各版本的更新日期、安装包体积与本次功能亮点，方便判断是否需要升级。"
          />

          <div className="flex items-center gap-1 bg-background-50 border border-background-200 rounded-full p-1 w-fit">
            {versionFilters.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setFilter(item.key)}
                className={`px-4 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap ${
                  filter === item.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-700"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {list.map((item) => (
            <article
              key={item.version}
              className="bg-background-50 border border-background-200 rounded-lg p-6 flex flex-col"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-xl">
                    <i
                      className={item.platform === "苹果" ? "ri-apple-line" : "ri-android-line"}
                      aria-hidden="true"
                    ></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {item.version}
                    </h3>
                    <p className="text-xs text-foreground-500">
                      {item.platform}版 · {item.date}
                    </p>
                  </div>
                </div>
                {item.tag ? (
                  <span className="text-[11px] font-medium text-accent-900 bg-accent-100 px-2.5 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                ) : (
                  <span className="text-[11px] text-foreground-500 bg-background-100 px-2.5 py-0.5 rounded-full">
                    历史版本
                  </span>
                )}
              </div>

              <ul className="mt-4 space-y-2.5 grow">
                {item.highlights.map((h) => (
                  <li key={h} className="flex gap-2 text-xs md:text-sm leading-relaxed text-foreground-700">
                    <i className="ri-flashlight-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                    <span>{h}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600">
                  <i className="ri-hard-drive-2-line" aria-hidden="true"></i>
                  安装包 {item.size}
                </span>
                <a
                  href={item.platform === "苹果" ? "#ios" : "#android"}
                  className="inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
                >
                  获取该版本
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs md:text-sm leading-relaxed text-foreground-600 bg-background-50 border border-background-200 rounded-lg p-5">
          <strong className="text-foreground-900">升级提示：</strong>
          若当前版本运行稳定，可按需选择是否升级；遇到闪退、无法联网等问题时，建议更新到对应平台的最新版后再排查。
          企业级证书类安装包存在有效期限制，失效后需回到本页重新获取最新安装包。
        </p>
      </div>
    </section>
  );
}